import { mapValues } from 'lodash';
import { setIn } from 'icepick';

/**
 * Version 9 migrations for the event website.
 * Add default padding settings to session filters
 */
export default function v9(website) {
  return {
    ...website,
    eventVersion: 9,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'Sessions') {
        return setIn(layoutItem, ['config', 'style', 'sessionFilter', 'filterDropdownStyles'], {
          styleMapping: 'input',
          customSettings: {
            spacing: {
              padding: {
                paddingTop: 5,
                paddingRight: 10,
                paddingBottom: 5,
                paddingLeft: 15
              }
            }
          }
        });
      }
      return layoutItem;
    })
  };
}
